
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import RecipeService, { FullData, Recipe } from '@/services/recipes.service';

@Component
export default class ExtendFatNutrients extends Vue {
  @Prop() private model!: Recipe;

  updateValue() {
    const value = this.model.extend_fat_nutrients;
    RecipeService.updateOne(this.model.id, {
        extend_fat_nutrients: value,
      }).then((data:FullData) => {
            this.$store.commit('updateRecipe', data.label);
            this.$store.commit('updateTable', data.table);
      }).catch(error => {
        console.log(error);
      });
  }
}
